var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-[10] mp-bottompc"})
}
var staticRenderFns = []

export { render, staticRenderFns }